import { shallowEqual, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import Config from '@/config'
import { CATALOG_CODES, EXTERNAL_URLS, LANGUAGE_LOCALES_CODE } from '@/constants'
import { getURL } from '@domain/infrastructure'

export default function useExternalUrls() {
	const vibiaWebPath = Config.getInstance().getConfig('endpoints.vibia-public.url')
	const subdomain = Config.getInstance().getConfig('endpoints.vibia-public.subdomain')
	let vibiaWebUrl = getURL(vibiaWebPath, subdomain)

	const { locale } = useIntl()

	const navigation = useSelector(state => state.ui.navigation, shallowEqual)

	const getExternalUrl = (type) => {
		const url = EXTERNAL_URLS[type][LANGUAGE_LOCALES_CODE[locale]] || '/'

		if (vibiaWebUrl.endsWith('/')) {
			vibiaWebUrl = vibiaWebUrl.slice(0, -1)
		}

		return url
			.replace('%VIBIA_WEB_URL%', vibiaWebUrl)
			.replace('%LANG%', LANGUAGE_LOCALES_CODE[locale])
			.replace('%CATALOG_CODE%', CATALOG_CODES[navigation.catalog])
	}

	return {
		getExternalUrl
	}
}
